/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxFudisModule } from '@funidata/ngx-fudis';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';
import { SisCommonModule } from 'sis-common';
import { SisComponentsModule } from 'sis-components';
import { OpenUniversityCommonModule } from '../common/open-university-common.module';
import { CartAccordionsComponent } from './cart-accordions/cart-accordions.component';
import { CartContainerComponent } from './cart-container/cart-container.component';
import { CartErrorComponent } from './cart-error/cart-error.component';
import { CartWizardContainerComponent } from './cart-wizard-container/cart-wizard-container.component';
import { CartWizardStepHeadingComponent } from './cart-wizard-container/cart-wizard-step-heading/cart-wizard-step-heading.component';
import { CeeposPaymentCompleteComponent } from './ceepos-payment-complete/ceepos-payment-complete.component';
import { CartCheckSelectionsComponent } from './check-selections/cart-check-selections.component';
import { CartPriceComponent } from './check-selections/cart-price/cart-price.component';
import { EmptyCartComponent } from './check-selections/empty-cart/empty-cart.component';
import { MonetaryPaymentConfirmationComponent } from './confirmation/monetary-payment-confirmation/monetary-payment-confirmation.component';
import { StudyVoucherPaymentConfirmationComponent } from './confirmation/study-voucher-payment-confirmation/study-voucher-payment-confirmation.component';
import { StudyVoucherVerifyIdentityComponent } from './confirmation/study-voucher-payment-confirmation/study-voucher-verify-identity/study-voucher-verify-identity.component';
import { CartContactInformationComponent } from './contact-information/cart-contact-information.component';
import { OpenUniversityCartComponent } from './open-university-cart.component';
import { MonetaryPaymentFailedComponent } from './payment-failed/monetary-payment-failed/monetary-payment-failed.component';
import { PaymentFailedComponent } from './payment-failed/payment-failed.component';
import { StudyVoucherPaymentFailedComponent } from './payment-failed/study-voucher-payment-failed/study-voucher-payment-failed.component';
import { PaymentProcessingComponent } from './payment-processing/payment-processing.component';
import { PaytrailPaymentCompleteComponent } from './paytrail-payment-complete/paytrail-payment-complete.component';
import { StudyVoucherConfirmationCompletedComponent } from './study-voucher-confirmation-completed/study-voucher-confirmation-completed.component';
import { StudyVoucherEnrolledItemInfoComponent } from './study-voucher-confirmation-completed/study-voucher-enrolled-item-info/study-voucher-enrolled-item-info.component';
import { StudyVoucherStudiesActivateComponent } from './study-voucher-studies-activate/study-voucher-studies-activate.component';

@NgModule({
    declarations: [
        CartAccordionsComponent,
        CartCheckSelectionsComponent,
        MonetaryPaymentConfirmationComponent,
        CartContactInformationComponent,
        CartContainerComponent,
        CartPriceComponent,
        CeeposPaymentCompleteComponent,
        EmptyCartComponent,
        OpenUniversityCartComponent,
        MonetaryPaymentFailedComponent,
        PaymentFailedComponent,
        PaytrailPaymentCompleteComponent,
        CartErrorComponent,
        PaymentProcessingComponent,
        StudyVoucherPaymentConfirmationComponent,
        StudyVoucherVerifyIdentityComponent,
        StudyVoucherStudiesActivateComponent,
        StudyVoucherConfirmationCompletedComponent,
        StudyVoucherEnrolledItemInfoComponent,
        CartWizardContainerComponent,
        StudyVoucherPaymentFailedComponent,
        CartWizardStepHeadingComponent,
    ],
    imports: [
        CommonModule,
        OpenUniversityCommonModule,
        ReactiveFormsModule,
        SisCommonModule,
        SisComponentsModule,
        TranslateModule.forChild(),
        UIRouterModule,
        NgxFudisModule,
    ],
})
export class CartPurchaseWizardModule {}
